import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getHasRecordOrigin } from "../../../store/modules/library/selectors";
import { getIsOrigin } from "../../../store/modules/display/selectors";
import { setIsOrigin } from "../../../store/modules/display/actions";

import { SwitchCheckbox } from "../SwitchCheckbox";

export const OriginControl: React.FC = () => {
  const dispatch = useDispatch();
  const isOrigin = useSelector(getIsOrigin);
  const hasRecordOrigin = useSelector(getHasRecordOrigin);

  const toggleIsOrigin = useCallback(() => {
    dispatch(setIsOrigin(!isOrigin));
  }, [isOrigin, dispatch]);

  return (
    <SwitchCheckbox
      label="Original Scan Mode"
      checked={isOrigin}
      disabled={!hasRecordOrigin}
      onChange={toggleIsOrigin}
    />
  );
};
